/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function UpArrow(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M3.85715 15.9L11.1768 8.58035C11.2302 8.52342 11.2948 8.47805 11.3664 8.44703C11.4381 8.41601 11.5153 8.40001 11.5934 8.40001C11.6714 8.40001 11.7487 8.41601 11.8203 8.44703C11.892 8.47805 11.9565 8.52342 12.0099 8.58035L19.3296 15.9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

UpArrow.defaultProps = {
  color: "currentColor",
  size: 24,
};

UpArrow.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
